import { SET_CRUMBS } from 'b2b-apps/shop/breadcrumbs/redux/actionTypes';
import {
  BreadcrumbsActions,
  BreadcrumbsState,
} from 'b2b-apps/shop/breadcrumbs/redux/types';

const initialState: BreadcrumbsState = {
  crumbs: [],
};

const reducer = (
  state: BreadcrumbsState = initialState,
  action: BreadcrumbsActions,
): BreadcrumbsState => {
  switch (action.type) {
    case SET_CRUMBS:
      return {
        crumbs: action.payload.crumbs,
      };

    default:
      return state;
  }
};

export {
  reducer,
};
